import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { ThreeFieldReflection } from '../interactions/ThreeFieldReflection.jsx'

const WLB_FIELDS = [
  { key: 'worked',  label: 'worked',  color: 'var(--moss-500)' },
  { key: 'learned', label: 'learned', color: 'var(--olive-500)' },
  { key: 'blocked', label: 'blocked', color: 'var(--rust-500)' },
]

/**
 * WLBCard — three coloured fields (Worked / Learned / Blocked).
 * catalog #9, prep-wlb. Greenfield card; reuses ThreeFieldReflection.
 */
export function WLBCard({ card, value, onChange, disabled }) {
  const hasFill = WLB_FIELDS.some((f) => value?.[f.key])

  return (
    <CardFrame
      kind="prep"
      icon="↺"
      iconClass="moss"
      title="Reflection — W / L / B"
      prompt="What worked, what didn't, what's blocking you?"
      state={disabled ? 'locked' : hasFill ? 'filled' : 'empty'}
      data-testid="prep-card-prep-wlb"
      className="prepcard"
    >
      <ThreeFieldReflection
        fields={WLB_FIELDS}
        values={value ?? {}}
        onChange={onChange}
        maxChars={200}
        disabled={disabled}
      />
    </CardFrame>
  )
}
